/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable camelcase */
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  InputBase,
  Link,
  Paper,
  // TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from 'formik-mui';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import copy from 'copy-to-clipboard';
import { AES, enc } from 'crypto-js';
import { Field, Form, Formik } from 'formik';
import io from 'socket.io-client';
import * as Yup from 'yup';
import {
  baseUrlApp,
  blockQuiry_connect_secret,
} from '../../../next-sitemap.config';

import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import { tokens } from '../../../src/tokens';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import LinkIcon from '@mui/icons-material/Link';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import URoomQRCode from '../../../src/components/messages/components/URoomQRCode';

const DynamicTooltip = dynamic(() => import('@mui/material/Tooltip'), {
  ssr: false, // Disable server-side rendering for the Tooltip component
});

const EntityTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.87500rem',
  lineHeight: '1.00rem',
  fontWeight: 500,
  letterSpacing: '.0107142867em',
  color: tokens.palette_primary,
  textAlign: 'left',
}));

const OriginTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.87500rem',
  lineHeight: '1.00rem',
  fontWeight: 400,
  letterSpacing: '.0107142867em',
  color: tokens.token_text_grey_on_white,
  textAlign: 'left',
}));

function MessageApp() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const appBarHeight = isMobile ? 100 : 56;
  const cryptoSecretKey = blockQuiry_connect_secret;
  const baseUrl = baseUrlApp;

  const router = useRouter();

  const messageEl = useRef(null);

  const { agencyID, userName, roomID, colorCodeBackGround, colorCodeFont } =
    router.query;
  const [messages, setMessages] = useState([]);
  const [messagesWithEncrypted, setMessagesWithEncrypted] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [socketAuthWithoutAuth, setSocketWithoutAuth] = useState(null);
  const [getAgencyDataById, setGetAgencyDataById] = useState([]);
  const [base64Image, setBase64Image] = useState('');
  const [fileType, setFileType] = useState(null);
  const [tooltipMessage, setTooltipMessage] = useState('');
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [roomIdState, setRoomIdState] = useState();
  const [getMessageAgencyId, setGetMessageAgencyId] = useState();
  const [openSendConsentModal, setOpenSendConsentModal] = useState(false);
  const [dataSaveFlag, setDataSaveFlag] = useState(false);

  // socket connection
  const handleConnect = () => {
    const socketUrl = baseUrl;

    fetch('/api/socket');
    if (agencyID && userName) {
      const socket = io(
        `${socketUrl}?${'agencyType='}${agencyID}&name=${userName}`
      );
      socket.on('connect', () => {});
      setSocketWithoutAuth(socket);
    } else if (roomID && userName) {
      const socket = io(
        `${socketUrl}?${'roomId='}${roomID}&name=${userName}&role=user`
      );

      socket.on('connect', () => {});
      setSocketWithoutAuth(socket);
    }
  };

  const handleClickOpenSendConsentModal = () => {
    setOpenSendConsentModal(true);
  };
  const handleCloseSendConsentModal = () => {
    setOpenSendConsentModal(false);
  };

  // input value get
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // send message
  const handleSendMessage = (e) => {
    if (inputValue.trim() !== '' || base64Image) {
      const secretKey = cryptoSecretKey; // Secret key for encryption
      const encryptionText = AES.encrypt(inputValue, secretKey).toString();
      const encryptionBase64Image = AES.encrypt(
        base64Image,
        secretKey
      ).toString();
      // The encryptionText variable now contains the encrypted data

      const eventDataSend = {
        id: messages.length + 1,
        isAgent: 0,
        message: encryptionText,
        name: userName,
        image: encryptionBase64Image,
        fileType: fileType?.type,
        colorCodeBackGround: colorCodeBackGround,
        colorCodeFont: colorCodeFont,
        ...(dataSaveFlag && { isChatStore: true }),
      };
      const eventData = {
        id: messages.length + 1,
        isAgent: 0,
        message: inputValue,
        name: userName,
        image: base64Image,
        fileType: fileType?.type,
        colorCodeBackGround: colorCodeBackGround,
        colorCodeFont: colorCodeFont,
        ...(dataSaveFlag && { isChatStore: true }),
      };
      if (socketAuthWithoutAuth) {
        socketAuthWithoutAuth.emit('sendMessage', eventDataSend);
        setMessages((prevMessages) =>
          prevMessages.length === 0 ? [eventData] : [...prevMessages, eventData]
        );
        setMessagesWithEncrypted((prevMessages) =>
          prevMessages.length === 0
            ? [eventDataSend]
            : [...prevMessages, eventDataSend]
        );
        setBase64Image('');
      }

      setInputValue('');
    }
  };
  // for decline consent
  const handleAcceptDeclineConsent = (data) => {
    const secretKey = cryptoSecretKey; // Secret key for encryption
    const encryptionText = AES.encrypt(data, secretKey).toString();
    const eventDataSend = {
      id: messages.length + 1,
      isAgent: 0,
      message: encryptionText,
      name: userName,
      consentAccepted: data?.includes('Accept Consent') ? true : false,
      colorCodeBackGround: data?.includes('Accept Consent')
        ? tokens.token_green
        : tokens.token_red,
      colorCodeFont: tokens.token_grey_10,
    };
    const eventData = {
      id: messages.length + 1,
      isAgent: 0,
      message: data,
      name: userName,
      consentAccepted: data?.includes('Accept Consent') ? true : false,
      colorCodeBackGround: data?.includes('Accept Consent')
        ? tokens.token_green
        : tokens.token_red,
      colorCodeFont: tokens.token_grey_10,
    };
    if (socketAuthWithoutAuth) {
      socketAuthWithoutAuth.emit('sendMessage', eventDataSend);
      setMessages((prevMessages) =>
        prevMessages.length === 0 ? [eventData] : [...prevMessages, eventData]
      );
      setMessagesWithEncrypted((prevMessages) =>
        prevMessages.length === 0
          ? [eventDataSend]
          : [...prevMessages, eventDataSend]
      );
      setBase64Image('');
    }
  };

  // for sending message by pressing enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      handleSendMessage();
    }
  };
  // Copy link
  const handleCopy = () => {
    const textToCopy = `${baseUrlApp}blockquiry_connect/u/chat_room?roomId=${roomIdState}`;
    copy(textToCopy);
    setTooltipMessage('Link copied!');
    setIsTooltipOpen(true);

    setTimeout(() => {
      setIsTooltipOpen(false);
    }, 2000);
  };

  const handleHoverToolTip = () => {
    setTooltipMessage('Copy Link');
    setIsTooltipOpen(true);
  };

  const handleHoverOffToolTip = () => {
    setIsTooltipOpen(false);
  };

  // page back
  const handleBack = () => {
    router.push('/blockquiry_connect/u/select_agency');
    window.location.href = '/blockquiry_connect/u/select_agency';
  };

  // agency data get by id
  const getAgencyDataApiById = () => {
    if (agencyID || getMessageAgencyId) {
      axios
        .get(`/api/agencies/${agencyID || getMessageAgencyId}`)
        .then((response) => {
          setGetAgencyDataById(response.data.data); // Store the API response in state
          setGetMessageAgencyId('');
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  };

  // image upload
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setFileType(file);
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      setBase64Image(base64String);
      handleSendMessage();
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  // crome back button click
  const handleBackButtonCrome = (event) => {
    // Handle the back button event here
    event.preventDefault();
    if (socketAuthWithoutAuth) {
      socketAuthWithoutAuth.disconnect();
    }
  };

  useEffect(() => {
    const refreshFunction = () => {
      if (socketAuthWithoutAuth) {
        socketAuthWithoutAuth.disconnect();
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', refreshFunction);

      return () => {
        window.removeEventListener('beforeunload', refreshFunction);
      };
    }
  }, []);

  useEffect(() => {
    const handleWindowBackButton = (event) => handleBackButtonCrome(event);

    window.addEventListener('popstate', handleWindowBackButton);

    return () => {
      window.removeEventListener('popstate', handleWindowBackButton);
    };
  }, []);

  useEffect(() => {
    const refreshFunction = () => {};

    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', refreshFunction);

      return () => {
        window.removeEventListener('beforeunload', refreshFunction);
      };
    }
  }, []);

  useEffect(() => {
    handleConnect();
    if (agencyID) {
      getAgencyDataApiById();
    }
  }, [agencyID]);

  useEffect(() => {
    if (getMessageAgencyId) {
      getAgencyDataApiById();
    }
  }, [getMessageAgencyId]);

  useEffect(() => {
    if (socketAuthWithoutAuth) {
      const secretKey = cryptoSecretKey; // Secret key for encryption

      socketAuthWithoutAuth.on('getMessage', (data) => {
        if (data.id) {
          // message decrypt
          const messageBytes = AES.decrypt(data.message, secretKey);
          const decryptedText = messageBytes.toString(enc.Utf8);
          // image decrypt
          const ImageBytes = AES.decrypt(data.image, secretKey);
          const decryptedBase64Image = ImageBytes.toString(enc.Utf8);
          const decryptedData = {
            id: data.id,
            isAgent: data.isAgent,
            message: decryptedText,
            name: data.name,
            image: decryptedBase64Image,
            fileType: data.fileType,
            colorCodeBackGround: data.colorCodeBackGround,
            colorCodeFont: data.colorCodeFont,
          };
          const withOutDecryptedData = {
            id: data.id,
            isAgent: data.isAgent,
            message: data.message,
            name: data.name,
            image: data.image,
            fileType: data.fileType,
            colorCodeBackGround: data.colorCodeBackGround,
            colorCodeFont: data.colorCodeFont,
          };
          setMessages((prevMessages) =>
            prevMessages.length === 0
              ? [data]
              : [...prevMessages, decryptedData]
          );
          setMessagesWithEncrypted((prevMessages) =>
            prevMessages.length === 0
              ? [data]
              : [...prevMessages, withOutDecryptedData]
          );
        } else {
          const withOutDecryptedData = {
            id: data.id,
            isAgent: data.isAgent,
            message: data.message,
            name: data.name,
            roomId: data.roomId,
            code: data.code,
            agencyId: data.agencyId,
            colorCodeBackGround: data.colorCodeBackGround,
            colorCodeFont: data.colorCodeFont,
          };
          withOutDecryptedData.roomId &&
            setRoomIdState(withOutDecryptedData.roomId);
          withOutDecryptedData.agencyId &&
            setGetMessageAgencyId(withOutDecryptedData.agencyId);
          setMessages((prevMessages) =>
            prevMessages.length === 0
              ? [data]
              : [...prevMessages, withOutDecryptedData]
          );
          setMessagesWithEncrypted((prevMessages) =>
            prevMessages.length === 0
              ? [data]
              : [...prevMessages, withOutDecryptedData]
          );
        }
        if (data.code === 1006) {
          handleConnect();
        }
        if (data.sendConsentLink == 'http://Consent/') {
          // setOpenSendConsentModal(true);
        }
      });
    }
  }, [socketAuthWithoutAuth]);

  useEffect(() => {
    if (messageEl) {
      messageEl.current.addEventListener('DOMNodeInserted', (event) => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight, behavior: 'smooth' });
      });
    }
  }, []);

  // page style
  const WebStyle = {
    user_chat_section: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    user_chat_part: {
      display: 'flex',
      justifyContent: 'center',
    },
    user_chat_all_message: {
      backgroundColor: '#fff',
      width: '100%',
    },
    user_chat_all_message_head: {
      padding: '0 30px',
    },
    user_chat_message_inner: {
      height: 'calc(100vh - 141px)',
      overflow: 'auto',
      paddingTop: '10px',

      // Hide scrollbar for Chrome, Safari and Opera
      '&::-webkit-scrollbar': {
        display: 'none',
      },

      // Hide scrollbar for IE, Edge and Firefox
      msOverflowStyle: 'none', // IE and Edge
      scrollbarWidth: 'none', // Firefox
    },
    messages_agent_true: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
    },
    messages_agent_false: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
    },
    chat_message_received: {
      maxWidth: '325px',
      width: 'fit-content',
      wordBreak: 'break-word',
      borderRadius: '0px 10px 10px 10px',
      margin: '2px',
      fontFamily: 'Roboto,arial,sans-serif',
      color: tokens.palette_primary,
      fontWeight: '500',
      padding: '8px 24px 8px 14px',
    },
    chat_message_received_consent: {
      maxWidth: '325px',
      width: 'fit-content',
      wordBreak: 'break-word',
      borderRadius: '10px 10px 10px 10px',
      margin: '2px',
      fontFamily: 'Roboto,arial,sans-serif',
      color: tokens.token_grey_10,
      fontWeight: '500',
      padding: '8px 14px',
    },
    chat_message_accept_consent: {
      backgroundColor: tokens.token_green,
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
      '&:hover': {
        color: tokens.token_grey_10,
        backgroundColor: tokens.token_green,
      },
    },
    chat_message_decline_consent: {
      backgroundColor: tokens.token_red,
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
      '&:hover': {
        color: tokens.token_grey_10,
        backgroundColor: tokens.token_red,
      },
    },
    chat_message_send: {
      borderRadius: '10px 0px 10px 10px',
      background: tokens.palette_primary,
      maxWidth: '325px',
      width: 'fit-content',
      wordBreak: 'break-word',
      margin: '2px',
      fontFamily: 'Roboto,arial,sans-serif',
      color: tokens.token_surface,
      fontWeight: '500',
      padding: '8px 14px 8px 24px',
    },
    message_font: {
      fontSize: '18px',
    },
    consent_button_font: {
      fontSize: '14px',
    },
    message_user_name: {
      fontSize: '16px',
      color: 'rgba(109, 110, 111, 0.4)',
    },
    message_float_right: {
      float: 'right',
    },
    message_float_left: {
      float: 'left',
    },
  };

  // Consent form

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  };

  let validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    email: Yup.string().email('Invalid email').required('Required'),
    phone: Yup.number().required('Required'),
  });

  const onSubmit = (values) => {
    let agentIdFind = messages.filter((data) => data.isAgent == 1);
    const payload = {
      roomId: roomIdState,
      messages: messagesWithEncrypted,
      firstName: values?.firstName,
      lastName: values?.lastName,
      phone: values?.phone,
      email: values?.email,
      agentId: agentIdFind?.[0]?.name,
    };
    axios
      .post('/api/agents/saveMessages', payload)
      .then((response) => {
        handleAcceptDeclineConsent(
          `Accept Consent ${moment().format('MMMM Do YYYY, h:mm:ss a')}`
        );
        setDataSaveFlag(true);
        setOpenSendConsentModal(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <Box sx={WebStyle.user_chat_section}>
        <Box sx={WebStyle.user_chat_part}>
          <Box sx={WebStyle.user_chat_all_message}>
            <AppBar
              sx={{
                backgroundColor: tokens.token_surface,
                height: appBarHeight,
              }}
            >
              <Toolbar>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    handleBack();
                  }}
                >
                  <ArrowBackOutlinedIcon
                    sx={{
                      color: tokens.palette_primary,
                      cursor: 'pointer',
                      width: '24px',
                      height: '24px',
                      marginRight: '16px',
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'block' },
                  }}
                >
                  <Card elevation={0} sx={{ backgroundColor: 'transparent' }}>
                    <CardHeader
                      sx={{ padding: 0 }}
                      avatar={
                        <Avatar
                          variant="rounded"
                          src={getAgencyDataById?.image}
                          alt="country-flag"
                          sx={{
                            width: 32,
                            height: 24,
                            border: '1px solid transparent',
                          }}
                        />
                      }
                      title={
                        <EntityTypo
                          sx={{ fontSize: '0.775rem', lineHeight: '1.00rem' }}
                        >
                          {getAgencyDataById?.label}
                        </EntityTypo>
                      }
                      subheader={
                        <OriginTypo
                          sx={{
                            fontSize: '0.775rem',
                            lineHeight: '0.975rem',
                          }}
                        >
                          {getAgencyDataById?.location}
                        </OriginTypo>
                      }
                    />
                  </Card>
                </Box>
                <Box flexGrow={1} />
                <Box sx={{ width: '45px' }}>
                  <URoomQRCode
                    roomLink={`${baseUrlApp}blockquiry_connect / u / chat_room ? roomId = ${roomIdState}`}
                  />
                </Box>
                <Box sx={{ width: '45px' }}>
                  <DynamicTooltip
                    open={isTooltipOpen}
                    title={tooltipMessage}
                    placement="bottom"
                    arrow
                  >
                    <Button
                      onClick={() => {
                        handleCopy();
                      }}
                      onMouseEnter={() => {
                        handleHoverToolTip();
                      }}
                      onMouseLeave={() => {
                        handleHoverOffToolTip();
                      }}
                    >
                      <LinkIcon sx={{ color: tokens.palette_primary }} />
                    </Button>
                  </DynamicTooltip>
                </Box>
              </Toolbar>
              <Toolbar sx={{ display: { xs: 'block', md: 'none' } }}>
                <Card elevation={0} sx={{ backgroundColor: 'transparent' }}>
                  <CardHeader
                    sx={{ padding: 0 }}
                    avatar={
                      <Avatar
                        variant="rounded"
                        src={getAgencyDataById?.image}
                        alt="country-flag"
                        sx={{
                          width: 32,
                          height: 24,
                          border: '1px solid transparent',
                        }}
                      />
                    }
                    action={
                      <IconButton aria-label="settings">
                        <MoreVertIcon />
                      </IconButton>
                    }
                    title={
                      <EntityTypo
                        sx={{ fontSize: '0.775rem', lineHeight: '1.00rem' }}
                      >
                        {getAgencyDataById?.label}
                      </EntityTypo>
                    }
                    subheader={
                      <OriginTypo
                        sx={{
                          fontSize: '0.775rem',
                          lineHeight: '0.975rem',
                        }}
                      >
                        {getAgencyDataById?.location}
                      </OriginTypo>
                    }
                  />
                </Card>
              </Toolbar>
            </AppBar>
            <Box sx={WebStyle.user_chat_all_message_head}>
              <Box sx={WebStyle.user_chat_message_inner} ref={messageEl}>
                {messages.map((message) => (
                  <Box
                    sx={
                      message.code == 1111
                        ? WebStyle.messages_agent_false
                        : message.name == userName
                        ? WebStyle.messages_agent_false
                        : WebStyle.messages_agent_true
                    }
                  >
                    {message.message &&
                      (message.message == 'http://Consent/' ? (
                        <>
                          <Box>
                            <Button
                              sx={
                                message.code == 1111
                                  ? WebStyle.chat_message_send
                                  : message.name == userName
                                  ? WebStyle.chat_message_send
                                  : {
                                      ...WebStyle.chat_message_received_consent,
                                      ...WebStyle.chat_message_accept_consent,
                                    }
                              }
                              size="small"
                              key={message.id}
                              onClick={() => setOpenSendConsentModal(true)}
                            >
                              <Typography sx={WebStyle.consent_button_font}>
                                Accept Consent
                              </Typography>
                            </Button>

                            <Button
                              sx={
                                message.code == 1111
                                  ? WebStyle.chat_message_send
                                  : message.name == userName
                                  ? WebStyle.chat_message_send
                                  : {
                                      ...WebStyle.chat_message_received_consent,
                                      ...WebStyle.chat_message_decline_consent,
                                    }
                              }
                              size="small"
                              key={message.id}
                              onClick={() =>
                                handleAcceptDeclineConsent(
                                  `Decline Consent ${moment().format(
                                    'MMMM Do YYYY, h:mm:ss a'
                                  )}`
                                )
                              }
                            >
                              <Typography sx={WebStyle.consent_button_font}>
                                Decline Consent
                              </Typography>
                            </Button>
                          </Box>
                        </>
                      ) : (
                        <Box
                          sx={
                            message.code == 1111
                              ? WebStyle.chat_message_send
                              : message.name == userName
                              ? WebStyle.chat_message_send
                              : {
                                  ...WebStyle.chat_message_received,
                                  backgroundColor: message.colorCodeBackGround
                                    ? message.colorCodeBackGround
                                    : '#cdd2d5',
                                  color: message.colorCodeFont,
                                }
                          }
                          key={message.id}
                        >
                          <Typography sx={WebStyle.message_font}>
                            {message.message}
                          </Typography>
                        </Box>
                      ))}
                    {message.image && (
                      <>
                        {message?.fileType?.includes('image') && (
                          <img
                            src={message.image}
                            style={{ borderRadius: '10px', margin: '2px' }}
                            height="auto"
                            width="200px"
                            alt="Converted to Base64"
                          />
                        )}
                        {message?.fileType === 'application/pdf' && (
                          <embed
                            src={message.image}
                            type="application/pdf"
                            style={{ borderRadius: '10px', margin: '2px' }}
                            width="350px"
                            height="300px"
                          />
                        )}
                      </>
                    )}
                    <Typography
                      sx={
                        message.code == 1111
                          ? [
                              WebStyle.message_user_name,
                              WebStyle.message_float_right,
                            ]
                          : message.name == userName
                          ? [
                              WebStyle.message_user_name,
                              WebStyle.message_float_right,
                            ]
                          : [
                              WebStyle.message_user_name,
                              WebStyle.message_float_left,
                            ]
                      }
                    >
                      {message.name}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ display: 'flex', width: '100%' }}>
                <Paper
                  elevation={0}
                  component="form"
                  sx={{
                    p: '2px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    height: '47px',
                    border: `1px solid ${tokens.token_search_border_grey}`,
                    boxShadow: '0 4px 12px rgb(60 63 66 / 15%)',
                    borderRadius: '24px',
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Message"
                    inputProps={{ 'aria-label': 'Message' }}
                    value={inputValue}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    onKeyPress={handleKeyPress}
                  />

                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    color="primary"
                    sx={{ p: '10px' }}
                    aria-label="file-upload"
                  >
                    <input
                      // accept="image/*"
                      id="icon-button-file"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={handleImageUpload}
                    />
                    <label htmlFor="icon-button-file">
                      <IconButton color="primary" component="span">
                        <UploadFileOutlinedIcon />
                      </IconButton>
                    </label>
                  </IconButton>
                </Paper>
                <IconButton
                  sx={{ marginBottom: '30px' }}
                  onClick={(e) => handleSendMessage(e)}
                >
                  <SendOutlinedIcon
                    sx={{
                      color: tokens.palette_primary,
                      marginLeft: '10px',
                      height: '30px',
                      width: '30px',
                      '&:hover': {
                        // color: tokens.palette_secondary,
                      },
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* SendConsentModal UI */}
      <Dialog
        open={openSendConsentModal}
        onClose={handleClickOpenSendConsentModal}
        fullWidth
        maxWidth="sm"
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ dirty, isValid, values, handleChange, handleBlur }) => {
            return (
              <Form>
                <DialogTitle>Consent form</DialogTitle>
                <Divider />
                <Divider />
                <DialogContent sx={{ padding: '0px 25px 0px 25px' }}>
                  <DialogContentText>
                    <Box sx={{ margin: '16px 0' }}>
                      <Grid item container spacing={2} justify="center">
                        <Grid item xs={12} sm={6} md={6}>
                          <Field
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            name="firstName"
                            value={values.firstName}
                            component={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <Field
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            name="lastName"
                            value={values.lastName}
                            component={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <Field
                            label="Email"
                            variant="outlined"
                            fullWidth
                            name="email"
                            value={values.email}
                            component={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <Field
                            label="Phone"
                            variant="outlined"
                            fullWidth
                            name="phone"
                            value={values.phone}
                            component={TextField}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </DialogContentText>
                </DialogContent>
                <Divider />
                <Divider />
                <DialogActions>
                  <Button onClick={handleCloseSendConsentModal} color="primary">
                    Close
                  </Button>
                  <Button variant="text" type="submit" onSubmit={onSubmit}>
                    Accept Consent
                  </Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
}

export default MessageApp;